/* ============
 * Flatpickr
 * ============
 *
 * Lightweight and powerful datetime picker.
 *
 * https://flatpickr.js.org/
 *
 * Wrapper: Vue-flatPickr - https://github.com/ankurk91/vue-flatpickr-component
 */

import 'flatpickr/dist/flatpickr.css';



// WEBPACK FOOTER //
// ./src/plugins/flatpickr.js